import React, { useCallback } from "react";
import styles from "./benefits.module.scss";
import { cn } from "utils";
import Input from "components/Input";
import Select from "components/Select";
import SubmitButton from "components/SubmitButton";
import { options } from "constants/options";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmployeeBenefitInputs, employeeBenefitSchema } from "./const";

const AddEditEmployeeBenefit = () => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(employeeBenefitSchema)
    });

    console.log("errors", errors);

    const onSubmit = useCallback((values) => {
        console.log("values", values);
    }, [])

    return (
        <form
            className={cn("container-spacing pt-3 pb-5")}
            onSubmit={handleSubmit(onSubmit)}
        >
            <h3 className={cn("title mt-2")}>Add Benefit</h3>
            <div>
                <div>
                    <p className={cn("info-title mt-3")}>General Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Assigned Employee"
                                    fullWidth
                                    variant="flat"
                                    options={[]}
                                    {...register(EmployeeBenefitInputs.ASSIGNED_EMPLOYEE)}
                                    error={!!errors[EmployeeBenefitInputs.ASSIGNED_EMPLOYEE]}
                                    errorText={errors[EmployeeBenefitInputs.ASSIGNED_EMPLOYEE]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-4 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Start Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(EmployeeBenefitInputs.START_DATE)}
                                    error={!!errors[EmployeeBenefitInputs.START_DATE]}
                                    errorText={errors[EmployeeBenefitInputs.START_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="End Date"
                                    fullWidth
                                    variant="flat"
                                    type="date"
                                    {...register(EmployeeBenefitInputs.END_DATE)}
                                    error={!!errors[EmployeeBenefitInputs.END_DATE]}
                                    errorText={errors[EmployeeBenefitInputs.END_DATE]?.message}
                                />
                            </div>
                            <div className="col-lg-8 col-12">
                                <Input
                                    label="Company Benefit (Optional)"
                                    fullWidth
                                    variant="flat"
                                    {...register(EmployeeBenefitInputs.COMPANY_BENEFIT)}
                                    error={!!errors[EmployeeBenefitInputs.COMPANY_BENEFIT]}
                                    errorText={errors[EmployeeBenefitInputs.COMPANY_BENEFIT]?.message}
                                />
                            </div>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Type"
                                    fullWidth
                                    variant="flat"
                                    options={options}
                                    {...register(EmployeeBenefitInputs.TYPE)}
                                    error={!!errors[EmployeeBenefitInputs.TYPE]}
                                    errorText={errors[EmployeeBenefitInputs.TYPE]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={cn("info-title mt-3")}>Contribution Information</p>
                    <div className={cn("container-fluid padding-0")}>
                        <div className={cn("row")}>
                            <div className="col-lg-8 col-12">
                                <Select
                                    label="Contribution Period"
                                    fullWidth
                                    options={[]}
                                    {...register(EmployeeBenefitInputs.CONTRIBUTION_PERIOD)}
                                    error={!!errors[EmployeeBenefitInputs.CONTRIBUTION_PERIOD]}
                                    errorText={errors[EmployeeBenefitInputs.CONTRIBUTION_PERIOD]?.message}
                                />
                            </div>
                        </div>
                        <div className={cn("row g-3 mt-2")}>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Company Contribution*"
                                    fullWidth
                                    variant="flat"
                                    {...register(EmployeeBenefitInputs.COMPANY_CONTRIBUTION_1)}
                                    error={!!errors[EmployeeBenefitInputs.COMPANY_CONTRIBUTION_1]}
                                    errorText={errors[EmployeeBenefitInputs.COMPANY_CONTRIBUTION_1]?.message}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <Input
                                    label="Company Contribution*"
                                    fullWidth
                                    variant="flat"
                                    {...register(EmployeeBenefitInputs.COMPANY_CONTRIBUTION_2)}
                                    error={!!errors[EmployeeBenefitInputs.COMPANY_CONTRIBUTION_2]}
                                    errorText={errors[EmployeeBenefitInputs.COMPANY_CONTRIBUTION_2]?.message}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <SubmitButton
                        submitText="Add Benefit"
                    />
                </div>
            </div>
        </form>
    )
}

export default AddEditEmployeeBenefit;